import { Suspense, lazy } from 'react';
import SEO              from '../../components/SEO/SEO';
import Hero              from './sections/Hero';

/*
 * Arquitectura v2 (rediseño ago-2026). Orden + sticky bar:
 *   1. Hero · 2. Logos institucionales (TrustBadges) · 3. ¿Qué pierdes? (PorQueIngles)
 *   4. Prueba de Ubicación · 5. 3 Pilares/Metodología · 6. Certificaciones
 *   7. Convenios · 8. Testimonios · 9. Formulario (cierre/conversión)
 *   10. FAQ (reduce objeción) · 11. Noticias (retención, cerca del footer) · + Sticky bar.
 *
 * Fuera del render (componentes conservados en el repo / otras rutas): GuiaUsuario,
 * GaleriaPreview, QuienesSomos, CinfopBanner, CTAFinal, Metodologia.
 * Eliminados también del bundle: Equipo y Galería (arquitectura v2).
 */

// Below-fold — lazy-loaded para reducir TBT
const TrustBadges       = lazy(() => import('../../components/sections/TrustBadges/TrustBadges'));
const PorQueIngles      = lazy(() => import('./sections/PorQueIngles'));
const PruebaUbicacionCTA = lazy(() => import('./sections/PruebaUbicacionCTA'));
const TresPilares       = lazy(() => import('./sections/TresPilares'));
const Certificaciones   = lazy(() => import('./sections/Certificaciones'));
const NoticiasPreview   = lazy(() => import('./sections/NoticiasPreview'));
const Convenios         = lazy(() => import('./sections/Convenios'));
const Testimonios       = lazy(() => import('../../components/sections/Testimonios/Testimonios'));
const LeadQualForm      = lazy(() => import('./sections/LeadQualForm'));
const FAQHome           = lazy(() => import('./sections/FAQHome'));
const StickyCTABar      = lazy(() => import('../../components/layout/StickyCTABar/StickyCTABar'));

export default function Home() {
  return (
    <>
      {/*
        Organization + WebSite JSON-LD viven en public/index.html (fuente unica,
        servida a todos los bots con o sin JS). Se retiro <SchemaOrg /> de aqui
        para eliminar el nodo #organization/#website duplicado en el home y el
        aggregateRating no verificable (0 resenas reales en la BD).
      */}
      <SEO
        title="Cursos de Inglés en Costa Rica | American English"
        description="Academia de inglés en Costa Rica: +20 años, +40 sedes. Programa conversacional de 9 meses a nivel B2-C1, con certificación TOEIC/Oxford opcional. Prueba gratis."
        url="https://americanenglishforbusiness.com/"
      />
      {/* 1 · Hero — relevancia + CTA principal */}
      <Hero />
      <Suspense fallback={null}>
        {/* 2 · Logos institucionales — autoridad inmediata */}
        <TrustBadges />
        {/* 3 · ¿Qué pierdes cada día? — instalar urgencia */}
        <PorQueIngles />
        {/* 4 · Prueba de Ubicación — conversión (CTA principal) */}
        <PruebaUbicacionCTA />
        {/* 5 · 3 Pilares / Metodología — explicar el mecanismo */}
        <TresPilares />
        {/* 6 · Certificaciones — autoridad técnica */}
        <Certificaciones />
        {/* 7 · Convenios — autoridad de red (sin buscador) */}
        <Convenios />
        {/* 8 · Testimonios — prueba social */}
        <Testimonios />
        {/* 9 · Cierre — formulario de cualificación de leads (meta de conversión) */}
        <LeadQualForm />
        {/* 10 · FAQ — reduce objeción de último momento, justo después del formulario */}
        <FAQHome />
        {/* 11 · Noticias — retención de audiencia (SEO/branding), reubicada cerca del footer
                fuera del tramo principal de conversión */}
        <NoticiasPreview />
        {/* Sticky bar — conversión disponible en todo el scroll */}
        <StickyCTABar />
      </Suspense>
    </>
  );
}
